import { api } from "../ApiState";
import { IApiResponse } from "../../Types/ApiResponse.model";

export const addressApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // list
    getAddressList: builder.query<
      IApiResponse<any>,
      { search?: object; page?: number; deleted?: boolean }
    >({
      query: ({ search, page, deleted }) => ({
        url: "user/address/list",
        method: "GET",
        params: {
          ...(search && { search: JSON.stringify({ ...search }) }),
          ...(page && { page }),
          ...(deleted && { deleted }),
        },
      }),
      providesTags: ["Address"],
    }),

    // show
    getAddress: builder.query<any, number>({
      query: (id) => ({
        url: `user/address/${id}`,
        method: "GET",
      }),
      transformResponse(baseQueryReturnValue: IApiResponse) {
        return baseQueryReturnValue?.response?.data;
      },
      providesTags: ["Address"],
    }),

    // create
    storeAddress: builder.mutation<any, any>({
      query: (data) => ({
        url: "user/address",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => (result ? [{ type: "Address" }] : []),
    }),

    // update
    updateAddress: builder.mutation<
      IApiResponse<any>,
      { id: number; value: object }
    >({
      query: ({ id, value }) => ({
        url: `user/address/${id}`,
        method: "POST",
        body: { ...value, _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Address" }] : []),
    }),

    // delete
    deleteAddress: builder.mutation<IApiResponse<any>, number>({
      query: (id) => ({
        url: `user/address/${id}`,
        method: "POST",
        body: { _method: "DELETE" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Address" }] : []),
    }),

    // pending
    pendingAddressStatus: builder.mutation<IApiResponse<any>, number>({
      query: (id) => ({
        url: `user/address/change-status-to-pending/${id}`,
        method: "POST",
        body: { _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Address" }] : []),
    }),

    // chnage status
    changeAddressStatus: builder.mutation<
      IApiResponse<any>,
      { id: number; value: object }
    >({
      query: ({ id, value }) => ({
        url: `user/address/change-status-to-accept/${id}`,
        method: "POST",
        body: { ...value, _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Address" }] : []),
    }),

    // cities list
    getCitiesList: builder.query<any, number>({
      query: (id) => ({
        url: `province/${id}`,
        method: "GET",
      }),
      transformResponse(baseQueryReturnValue: IApiResponse) {
        return baseQueryReturnValue?.response?.data;
      },
    }),

    // provinces and cities list
    getProvincesList: builder.query<any, { city?: boolean }>({
      query: ({ city }) => ({
        url: "province/list",
        method: "GET",
        params: {
          ...(city && { city }),
        },
      }),
      transformResponse(baseQueryReturnValue: IApiResponse) {
        return baseQueryReturnValue?.response?.data;
      },
    }),
  }),
});

export const {
  useGetAddressListQuery,
  useGetAddressQuery,
  useStoreAddressMutation,
  useUpdateAddressMutation,
  useDeleteAddressMutation,
  usePendingAddressStatusMutation,
  useGetCitiesListQuery,
  useGetProvincesListQuery,
  useChangeAddressStatusMutation,
} = addressApi;

export default addressApi;
